import React, { FC } from "react"
import { ShapeType } from "@dv5/domain"
import { SHAPE_TYPES } from "./constants"
import { shapeComponents } from "./shapes"

interface Props {
    value: ShapeType
    onChange: (shapeType: ShapeType) => void
    prefix: string
    columns?: number
}

const previewData = {
    shapeType: ShapeType.RECTANGLE,
    bgColor: 'transparent',
    borderColor: 'currentColor',
    borderWidth: 1.5,
    fgColor: 'currentColor',
}

const renderPreview = (shapeType: ShapeType): React.ReactNode => {
    const Component = shapeComponents[shapeType]
    return (
        <svg width='16' height='16' viewBox='0 0 16 16' preserveAspectRatio='none'>
            <Component data={{ ...previewData, shapeType }} width={16} height={16} />
        </svg>
    )
}

export const ShapePicker: FC<Props> = ({ value, onChange, prefix, columns }) => {
    const changeShape = (event: React.MouseEvent<HTMLButtonElement>, newType: ShapeType) => {
        event.preventDefault()
        event.stopPropagation()
        onChange(newType)
    }

    return (
        <div
            className={`${prefix}__shape-picker`}
            style={columns ? { display: 'grid', gridTemplateColumns: `repeat(${columns}, 1fr)` } : undefined}
        >
            {SHAPE_TYPES.map(shape => (
                <button
                    key={shape.value}
                    className={`${prefix}__button ${value === shape.value ? `${prefix}__button--active` : ''}`}
                    onMouseDown={event => changeShape(event, shape.value as ShapeType)}
                    aria-label={shape.value}
                    type='button'
                    title={shape.value}
                >
                    {renderPreview(shape.value as ShapeType)}
                </button>
            ))}
        </div>
    )
}
